import theme from './Theme'
import { ThemeProvider } from '@mui/material/styles'
import { Box, Container, CssBaseline, Link, Typography } from '@mui/material'
import { Head } from '@inertiajs/react'
import Logo from '../components/Logo'
import { Stack } from '@mui/material'
import { Notification } from '../components/Notificatiion'

export default function AuthLayout({ children, title }: { children: React.ReactNode, title: string }) {
  return (
    <main>
      <Head title={title} />
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Notification />
        <Box sx={{ 
            margin: 3,
            minHeight: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        }}>
          <Container sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
            <Box sx={{ 
              display: { mobile: 'none', tablet: 'none', desktop: 'none', desktop_wide: 'flex' }, 
              backgroundColor: "#FAF3E9", 
              justifyContent: 'center',
              padding: '40px',
              borderRadius: '20px',
              maxWidth: '582px',
              flex: '1',
              py: '60px',
              px: '80px',
            }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 3, flex: 1, minWidth: '370px' }}>
                <Typography fontSize={'18px'} fontWeight={'600'} color={theme.pandia.blue_600}>Patient experience:</Typography>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', flex: 1  }}>
                  <img src={'/icon-headache.png'} alt="Headache Icon" width={'120px'} height={'120px'}/>
                  <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                    <Typography variant='h3' fontWeight={'600'} color={theme.pandia.blue_600}>-87%</Typography>
                    <Typography fontSize={'18px'} fontWeight={'600'}>Reduction in headaches:</Typography>
                    <Typography fontSize={'18px'}>1.7% vs 14% standard of care</Typography>
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                  <img src={'/icon-nausea.png'} alt="Nausea Icon" width={'120px'} height={'120px'}/>
                  <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                    <Typography variant='h3' fontWeight={'600'} color={theme.pandia.blue_600}>-43%</Typography>
                    <Typography fontSize={'18px'} fontWeight={'600'}>Reduction in nausea:</Typography>
                    <Typography fontSize={'18px'}>2.3% vs 4% standard of care</Typography>
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                  <img src={'/icon-breakthrough-bleeding.png'} alt="Breakthrough Bleeding Icon" width={'120px'} height={'120px'} style={{ padding: '17px' }}/>
                  <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <Typography variant='h3' fontWeight={'600'} color={theme.pandia.blue_600}>-42%</Typography>
                    <span style={{ fontSize: '18px', fontWeight: '600' }}>Reduction in breakthrough:</span>
                    <span style={{ fontSize: '18px', fontWeight: '600' }}>bleeding:</span>
                    <Typography fontSize={'18px'}>3.5% vs 6% standard of care</Typography>
                  </Box>
                </Box>
                <Link
                  href="https://bc.pandiahealth.com/precision-matching-data/" 
                  style={{justifySelf: 'flex-end', alignSelf: 'center', fontSize: '14px', fontWeight: '600'}}
                >
                  See data in more detail
                </Link>
              </Box>
            </Box>
            <Box sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '20px',
              maxWidth: '582px',
              backgroundColor: theme.pandia.indigo_dark,
              minHeight: '615px',
              py: "80px", px: {mobile: '40px', tablet_wide: '100px'}
              }}
            >              <Stack spacing={ 0} alignItems="center">

                <Logo width={'inherit'} color="white" withPandia={true}/>

              {children}
            </Stack>
            </Box>
          </Container>
        </Box>
      </ThemeProvider>
    </main>
  )
}